// import isMobilePhone from "validator/lib/isMobilePhone";

const validator = (phone) => {
  phone = phone.replace(/\D/g, "");
  return phone.length >= 10 && phone.length <= 15;
};

export default validator;
